import { defaultOrgColors } from "src/utils/constants";
import tw from "src/utils/tw";

interface Props {
  value?: string;
  onChange?: (color) => void;
  disabled?: boolean;
}

interface ColorBlockProps {
  color?: string;
  className?: string;
  selected: boolean;
  onClick: () => void;
}

function ColorBlock(props: ColorBlockProps) {
  return (
    <div
      onClick={props.onClick}
      className={tw(
        "h-10 border-2",
        props.selected ? "border-dark" : "border-transparent"
      )}
      css={{ backgroundColor: props.color }}
    />
  );
}

export function ColorPicker(props: Props) {
  function selectColor(color) {
    props.onChange(color.replace("#", ""));
  }

  const colors = defaultOrgColors.map((c) => {
    return (
      <ColorBlock
        key={c}
        selected={c === props.value}
        onClick={() => selectColor(c)}
        color={c}
      />
    );
  });

  return (
    <section
      className={tw(
        "grid max-w-sm grid-cols-8 overflow-hidden rounded",
        props.disabled ? "pointer-events-none opacity-70" : "cursor-pointer"
      )}
    >
      {colors}
    </section>
  );
}
